// @flow
import api from '../api/catalogLocation';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import ms from 'ms';

/* Action Types */
export const LOAD_CATALOG_LOCATIONS_FAIL = 'la/domain/catalogLocation/LOAD_FAIL';
export const LOAD_CATALOG_LOCATIONS_REQUEST = 'la/domain/catalogLocation/LOAD_REQUEST';
export const LOAD_CATALOG_LOCATIONS_SUCCESS = 'la/domain/catalogLocation/LOAD_SUCCESS';

const REDUX_STORE_TIME = ms('30m');

/* reducer */
const DEFAULT_STATE = {
    byId: {},
    loaded: 0,
    loadedCatIds: {},
    loadedSellerIds: {},
    loading: false,
    locations: [],
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_CATALOG_LOCATIONS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case LOAD_CATALOG_LOCATIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_CATALOG_LOCATIONS_SUCCESS:
            return {
                ...state,
                loaded: action.meta.actionTime,
                loading: false,
                locations: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.catalogLocation;

export const getCatalogLocations = createSelector(stateSelector, state => state.locations);

const getLoadTimeForCatalogLocations = createSelector(stateSelector, state => state.loaded);

export const areCatalogLocationsLoading = createSelector(stateSelector, state => state.loading);

const shouldFetchCatalogLocations = state => {
    const item = getCatalogLocations(state);
    if (item) {
        const loaded = getLoadTimeForCatalogLocations(state);
        const time = Date.now();
        const diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    const loading = areCatalogLocationsLoading(state);
    return !loading;
};

/* ACTION CREATORS */
const loadCatalogLocations = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        dispatch({
            type: LOAD_CATALOG_LOCATIONS_REQUEST,
        });
        const response = await api.fetchCatalogLocations({ deployment });

        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: LOAD_CATALOG_LOCATIONS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOAD_CATALOG_LOCATIONS_FAIL,
        });
    }
};

export const fetchCatalogLocationsIfNeeded = () => async (dispatch: Function, getState: Function) => {
    if (shouldFetchCatalogLocations(getState())) {
        return dispatch(loadCatalogLocations());
    }
    return Promise.resolve();
};
